import * as yup from "yup";

export const processPaymentSchema = yup.object().shape({
  payment_method: yup
    .string()
    .oneOf(["balance", "credit_card", "pix"], "Método de pagamento inválido")
    .required("Método de pagamento é obrigatório"),
  amount: yup.number().positive("O valor deve ser positivo").optional(),
});

export const billingConfigSchema = yup.object().shape({
  preferred_charge_source: yup
    .string()
    .oneOf(
      ["system", "establishment_balance", "pix"],
      "Fonte de cobrança inválida",
    )
    .required("Fonte de cobrança é obrigatória"),
});

export const paymentFiltersSchema = yup.object().shape({
  status: yup
    .string()
    .oneOf(["paid", "pending", "failed", "cancelled"])
    .optional(),
  start_date: yup
    .string()
    .matches(/^\d{4}-\d{2}-\d{2}$/, "Data deve estar no formato YYYY-MM-DD")
    .optional(),
  end_date: yup
    .string()
    .matches(/^\d{4}-\d{2}-\d{2}$/, "Data deve estar no formato YYYY-MM-DD")
    .optional(),
  per_page: yup
    .number()
    .integer("Deve ser um número inteiro")
    .min(1, "Mínimo 1 item por página")
    .max(100, "Máximo 100 itens por página")
    .optional(),
  page: yup
    .number()
    .integer("Deve ser um número inteiro")
    .min(1, "Página deve ser no mínimo 1")
    .optional(),
});
